const LANGUAGE = {
  titleVideos: 'Vídeos',
  titleCadastroVideos: 'Cadastro de vídeo',
  fieldNome: 'Nome',
  fieldDigiteNome: 'Digite o nome',
  fieldVideoMasculino: 'Vídeo masculino',
  fieldVideoFeminino: 'Vídeo feminino',
  fieldEmail: 'Email',
  fieldDigiteEmail: 'Digite o email',
  observacoes: 'Observações',
  salvar: 'Salvar',
  msgCamposObrigatoriosVideos: 'Preencha o nome do vídeo e adicione ao menos um vídeo',
  salvoSucesso: 'Item salvo com sucesso',
  atencao: 'Atenção',
  msgRemover: 'Tem certeza que deseja remover o item selecionado?',
  remover: 'Remover',
  fechar: 'Fechar',
  itemRemovidoSucesso: 'Item removido com sucesso',
  titleBlocos: 'Blocos diários',
  cadastroBloco: 'Cadastro de bloco diário',
  nomeBloco: 'Nome do bloco',
  digiteAqui: 'Digite aqui',
  sexo: 'Sexo',
  erroSalvarBloco: 'Ocorreu um erro ao salvar o bloco',
  preenchaCamposAsterisco: 'Preencha todos os campos com um asterisco',
  impossivelRemoverItem: 'Impossível remover o item',
  escolhaOsExercicios: 'Escolha os exercícios',
  erroSalvar: 'Ocorreu um erro ao salvar o item',
  erroRemover: 'Ocorreu um erro ao remover o item',
  erroDetalhe: 'Ocorreu um erro ao retornar os dados do item escolhido',
  masculino: 'Masculino',
  feminino: 'Feminino',
  titleBlocosPlanilha: 'Blocos semanais',
  copiarBlocoPlanilha: "Copiar bloco semanal",
  quantidadeDias : 'Quantidade de dias',
  adicionarBloco : 'Adicionar bloco',
  escolhaQntDias: 'Selecione a quantidade de dias da planilha',
  adicioneBlocos: 'Adicione blocos de exercícios a sua Planilha',
  qntBlocosMenorQueQntDias: 'A quantidade de blocos de exercícios deve ser igual a quantidade de dias',
  erroBlocoPlanilha: 'Ocorreu um erro ao gerar os dados do formulário',
  errorSaveBlocoPlanilha: 'Ocorreu um erro ao salvar o bloco de planilha',
  titlePlanilhasTreino: '20 modelos',
  cadastroPlanilha: 'Cadastro de 20 modelos',
  nome_planilha: 'Nome da Planilha',
  dataInicio: 'Data de início',
  dataFim: 'Data fim',
  copiarPlanilha: 'Copiar 20 modelos',
  carregandoPlanilha: "Carregando planilha, aguarde um instante!",
  criandoPlanilha: "Criando planilha, aguarde um instante!",
  digiteNomePlanilha: "Digite o nome da Planilha",
  erroDataPlanilha: 'As datas inicial e final devem ter 7 dias de diferença para completar uma semana de treino',
  erroDataSexoPlanilha: 'Ocorreu um erro ao gerar a planilha, tente novamente (1002x10)',
  msgQntPlanilhasMenorQue5: 'A quantidade de planilhas (hipertrofia e emagrecimento) femininas e masculinas deve ser 5 (2, 3, 4, 5 e 6 dias)! Selecione no select "Adicionar bloco de planilha" os 5 dias relacionados a cada planilha',
  algumaPlanilhaNaoTemExercico: 'Alguma das planilhas adicionadas não possui exercícios cadastrados. É necessário que cadastre ao enos um exercício na planilha.',
  verifiquePlanilhas: 'Verifique suas planilhas pois alguma delas tem a quantidade de blocos menor que a quantidade de dias. Por exemplo, se a quantidade de dias  é 2, o bloco de planilha deverá ter exatamente dois blocos.',
  errorSavePlanilha: 'ocorreu um erro ao salvar a planilha de treino',
  titleExercicios: 'Exercícios',
  imagemFeminina: 'Imagem feminina',
  imagemMasculina: 'Imagem masculina',
  selecioneVideo: 'Selecione o vídeo',
  cadastroExercicio: 'Cadastro de exercício',
  planosAlimentares: 'Planos alimentares',
  titulo: 'Título',
  cadastroPlanoAlimentar: 'Cadastro de plano alimentar',
  imagem: 'Imagem',
  linkYoutube: 'Link do youtube',
  planoMasculino: 'Plano masculino',
  planoFeminino: 'Plano feminino',
  ativar: 'Ativar',
  usuarioSenha: 'Digite o usuário e a senha',
  erroLogar: 'Ocorreu um erro ao se logar',
  selecioneExercicios: 'Selecione os exercícios',
  cadenciaTitle: 'Cadência',
  seriesRepeticoes: 'Séries/repetições',
  intervaloTitle: 'Intervalo',
  diaSemanaTitle: 'Dia da semana',
  nenhumItem: 'Nenhum item',
  exerciciosJaAdiconado: 'O exercício já foi adicionado!',
  adiconarBlocoPlanilha: 'Adicionar bloco de planilha (2,3,4,5 e 6 dias)',
  tipoDePlanilha: 'Tipo de planilha',
  impossivelRemover: 'Impossível remover o item selecionado',
  nomePlano: 'Nome do plano',
  periodicidade: 'Periodicidade',
  descricaoPlano: 'Resumo do plano',
  valorPlano: 'Valor',
  relatorios: 'Relatórios',
  treinoDomiciliar: 'Treino domiciliar',
  nomeTreinoDomiciliar: 'Nome do treino',
  titlePlanos: 'Planos',
  erroLoad: 'Ocorreu um erro ao carregar os dados da página',
  titleSobre: 'Sobre',
  titleTermos: 'Termos de uso',
  titleEbook: 'E-book',
  titlePerguntas: 'Perguntas frequentes',
  txtPergunta: 'Pergunta',
  txtResposta: 'Resposta',
  cadastroPergunta: 'Cadastro de pergunta',
  preenchaTodosCampos: 'Preencha todos os campos',
  titleUsuarios: 'Usuários',
  fieldMedidasUsuarios: 'Medidas do usuário',
  fieldPeso: 'Peso',
  fieldAltura: 'Altura',
  fieldGordCorp: 'Gord. corporal',
  fieldBicepsDir: 'Bíceps direito',
  fieldBicepsEsq: 'Bíceps esquerdo',
  fieldAntebracoEsq: 'Antebraço esquerdo',
  fieldAntebracoDir: 'Antebraço direito',
  fieldCoxaDir: 'Coxa direita',
  fieldCxaEsq: 'Coxa esquerda',
  fieldPantEsq: 'Paturrilha esquerda',
  fieldPantDir: 'Panturrilha direita',
  fieldTorax: 'Tórax',
  fieldCintura: 'Cintura',
  fieldAbdomen: 'Abdomen',
  fieldQuadril: 'Quadril',
  fieldProblemasSaude: 'Problemas de saúde',
  fieldDataNascimento: 'Data de nascimento',
  fieldDigiteAqui: 'Digite aqui',
  fieldUf: 'UF',
  fieldNumero: 'Nº',
  fieldComplemento: 'Complemento',
  fieldCidade: 'Cidade',
  fieldCep: 'Cep',
  fieldBairro: 'Bairro',
  fieldLogradouro: 'Logradouro',
  titleOndeTreina: 'Onde treina',
  titleQtdDias: 'Dias de treino',
  titletipoTreino: 'Tipo de treino',
  titleTempoMusculacao: 'Tempo de musculação',
  titleMensagens: 'Mensagens',
  enviar: 'Enviar',
  digiteMensagem: 'Digite a mensagem',
  titleNewMessage: 'Nova mensagem',
  selecioneCliente: 'Selecione o cliente',
  assuntoTitle: 'Assunto',
  titleMensagem: 'Mensagem',
  circuito: 'Circuito',
  repeticoes: 'Repetições',
  sessoes: 'Sessões',
  titlePolitica: 'Política de privacidade',
  fieldTelefone: 'Telefone',
  txtCpf: 'Cpf',
  txtDataNasc: 'Data de nascimento',
  txtTel: 'Telefone celular',
  txtSenha: 'Senha',
  txtConfirmarSenha: 'Confirmar senha',
  txtSenhaAntiga: 'Senha antiga',
  txtEstado: 'Estado',
  escolhaEstado: 'Escolha o estado',
  txtCidade: 'Cidade',
  digiteCidade: 'Digite a cidade',
  txtBairro: 'Bairro',
  digiteBairro: 'Digite o bairro',
  txtLogradouro: 'Logradouro',
  digiteLogradouro: 'Digite o logradouro',
  txtComplemento: 'Complemento',
  digiteComplemento: 'Digite o complemento',
  txtNumero: 'Nº',
  digiteNumero: 'Digite o nº',
  txtCep: 'Cep',
  digiteCep: 'Digite o cep',
  txtCadencia: 'Cadência',
  txtIntervalo: 'Intervalo',
  txtRepeticoes: 'Repetições',
  titleTreino: 'Treino',
  problemasSaude: 'Possui algum desses problemas de saúde?',
  cardiaco: 'Problemas cardíacos',
  renais: 'Problemas renais',
  diabetes: 'Diabetes',
  ombros: 'Dor nos ombros',
  coluna: 'Dor na coluna',
  joelhos: 'Dor nos joelhos',
  outrosProblemas: 'Caso tenha outros problemas de saúde, por favor informe logo abaixo:',
  digiteProblema: 'Digite o problema de saúde',
  obsProblema: 'Obs: Adicione um de cada vez',
  manNotAllowd: 'O Foco90 ainda não possui treinos específicos para homens. Estamos trabalhando arduamente para que os homens também possam fazer parte do Foco90. Em breve teremos novidades!',
  txtSessoes: 'Sessões',
  txtRepeticoes: 'Repetições',
  txtCircuito: 'Circuito',
  txtNome: 'Nome',
  txtEmailCadastro: 'E-mail',
  txtTipoTreino: 'O que procura?',
  txtOndeTreina: 'Onde irá treinar?',
  txtQuantidadeDias: 'Quantos dias irá treinar?',
  txtTempoMusculacao: 'Já faz musculação a quanto tempo?',
  txtSalvar: 'Salvar',
  buscar: 'Buscar',
  descricaoPlanoCompleto: 'Descrição completa',
  dataCriacao: 'Data de criação: ',
  clienteCancelado: 'O plano do cliente foi cancelado',
  qtdParcelas: 'Nº máximo de parcelas',
  clientesAtivos: 'Clientes ativos',
  clientesInativos: 'Clientes inativos',
  adesoes: 'Adesões',
  procurar: 'Procurar',
  adesoesAtual:'Adesões do mês atual',
  adesoesAnterior: 'Adesões do mês anterior',
  adesoesBoleto: 'Adesões no boleto',
  adesoesCartao: 'Adesões no cartão',
  planosClientes: 'Clientes por plano',
  planosMais: 'Planos com mais clientes',
  planosData: 'Clientes por data',
  txtValidade: 'Validade',
  relatorioGeral: 'Relatório geral',
  cancelamentos: 'Cancelamentos',
  cadastrados: 'Cadastrados',
  btCriarBlocoMasculino: 'Criar treino masculino',
  btCriarBlocoFeminino: 'Criar treino feminino',
  primeiro_pagamento: "Primeiro pagamento",
  clientesNaoPagantes: "Clientes não pagantes",
  clientesEmTeste: "Clientes em teste",
  clientesPagantes: "Clientes pagantes(ativos)",
  clientesInativos: "Clientes inativos",
  clientesTestaramNaoPagaram: "Clientes que testaram e não pagaram",
  selecionePlano: "Selecione o plano",
  limpar: "Limpar",
  relatorioPagamentos: "Clientes",
  treinoHome: "Treino Home",
  adiconarBlocoPlanilhaHome: 'Adicionar bloco de planilha (2,3 dias)',
  tipoBloco: 'Tipo de treino',
  treinoCasa: 'Casa',
  treinoAcademia: 'Academia',
  msgQntPlanilhasMenorQue2: 'A quantidade de planilhas femininas e masculinas deve ser 2! Selecione no select "Adicionar bloco de planilha" os 2 dias relacionados a cada planilha',
  idSuperlogica: 'Identificador plano Superlogica',
  copiarPlanilhaTreino: 'Clonar treino'

};

export default LANGUAGE;



// WEBPACK FOOTER //
// ./src/data/language/pt_br/language.js